module.exports = __webpack_public_path__ + "static/media/viber.d9ba3c98.svg";